var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { retrieveSchema, mergeObjects, toIdSchema, getDefaultRegistry, getUiOptions } from './';

export function getFieldType(props) {
    var type = props && props.schema && props.schema._type || props && props.schema && props.schema.type;
    var registry = props && props.registry || getDefaultRegistry();
    var fieldtypes = registry.fieldtypes;


    var field = {};

    if (type && type in fieldtypes) {
        var getField = fieldtypes[type];
        field = getField(_extends({}, props));

        field.schema = _extends({}, field.schema, {
            _type: type
        });
    } else {
        field = props;
    }

    return field;
}